import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import _ from 'lodash';
import { hashHistory } from 'react-router';

import { WidgetGrid, JarvisWidget } from '../../../components';
import VisitNotesTable from './VisitNotesTable';
import VisitNotesList from './VisitNotesList';
import VisitNotesListMobile from './VisitNotesListMobile';
import VisitView from './VisitView';
import FiltersForm from './ClinicActivity/FiltersForm';

import {
  requestActions,
  addAction,
  requestEncounters,
  requestBullets,
  requestVisitNote,
  requestMedications,
  requestAuditLog,
} from '../../../store/visit-notes/VisitNotesActions';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { requestClaimsHistory } from '../../../store/patients/PatientsActions';
import InfoBarBase from '../../../components/common/InfoBarBase';
import InfoBar from '../../../components/common/InfoBar';
import { BigBreadcrumbs } from '../../../components';
import {
  selectActions,
  selectEncounters,
  selectBullets,
  selectMedications,
} from '../../../store/visit-notes/VisitNotesSelectors';
import { isExecutive } from '../../../store/current-user/CurrentUserSelectors';

class ClinicActivityLayout extends React.Component {
  constructor(props) {
    super(props);

    const query = this.props.location.query;

    this.state = {
      showNotes: false,
      editFlagsMode: false,
      sort: 'desc dateOfService',
      filter: query.filter ? query.filter : '',
      filters: {},
      search: '',
      page: 0,
      perPage: 25,
      pages: -1,
      selectedNote: null,
      viewLayout: 'detail',
      queryParams: {},
    };
    this.prevNote = this.prevNote.bind(this);
    this.nextNote = this.nextNote.bind(this);
    this.toggleNotes = this.toggleNotes.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
  }

  componentWillMount() {
    if (this.props.currentUser.queryParams) {
      this.props.getAuditLog(this.props.currentUser.queryParams);
      this.setState({
        queryParams: this.props.currentUser.queryParams,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentUser.queryParams !== this.state.queryParams) {
      this.setState(
        {
          queryParams: nextProps.currentUser.queryParams,
        },
        () => this.fetch(),
      );
    }
  }

  changeView = (viewLayout) => this.setState({ viewLayout });

  toggleNotes = (editFlagsMode = false, forceShow = false) => {
    this.setState({
      showNotes: forceShow ? true : !this.state.showNotes,
      editFlagsMode,
    });
  };

  selectNote = (note, forceScroll) => {
    if (!note) {
      return false;
    }
    if (forceScroll) {
      const { VisitNotesList } = this.refs;
      if (VisitNotesList.refs[note.visitNoteID]) {
        VisitNotesList.refs[note.visitNoteID]
          .getWrappedInstance()
          .refs[note.visitNoteID].scrollIntoView({
            block: 'end',
            behavior: 'smooth',
          });
      }
    }
    const {
      data: { list },
    } = this.props;
    const pageIndex = list.findIndex((item) => item === note);
    return this.setState(
      {
        selectedNote: note,
        selectedNodeIndex: pageIndex,
      },
      () => {
        if (note) {
          this.props.getActions(note.visitNoteID, this.state.queryParams);
          this.props.getEncounters(
            note.patientID,
            note.visitNoteID,
            this.state.queryParams,
          );
          this.props.getBullets(note.visitNoteID, this.state.queryParams);
          this.props.getMedications(
            note.visitNoteID,
            note.patientID,
            note.dateOfService,
            this.props.currentUser.queryParams.tenantId,
          );
          this.props.getHistory(note.patientID, {
            tenantId: this.props.currentUser.queryParams.tenantId,
            from: note.dateOfService,
          });
        }
      },
    );
  };

  prevNote = () => {
    const {
      data: { list },
      isLoading,
    } = this.props;
    const { selectedNodeIndex, page, perPage } = this.state;
    if (isLoading) {
      return true;
    }
    if (list[selectedNodeIndex - 1]) {
      this.selectNote(list[selectedNodeIndex - 1], true);
    } else if (page >= 1) {
      this.preFetch(page - 1, perPage).then((response) => {
        const {
          payload: {
            data: { list: newList },
          },
        } = response;
        this.selectNote(newList[newList.length - 1], true);
      });
    }
  };

  nextNote = () => {
    const {
      data: { list, total },
      isLoading,
    } = this.props;
    if (isLoading) {
      return true;
    }
    const { selectedNodeIndex, page, perPage } = this.state;
    if (list[selectedNodeIndex + 1]) {
      this.selectNote(list[selectedNodeIndex + 1], true);
    } else if (page < total) {
      this.preFetch(page + 1, perPage).then((response) => {
        const {
          payload: {
            data: { list: newList },
          },
        } = response;
        this.selectNote(newList[0], true);
      });
    }
  };

  canPrevNote = () =>
    this.state.selectedNodeIndex > 0 ||
    (this.state.selectedNodeIndex === 0 && this.state.page >= 1);

  canNextNote = () =>
    this.props.data.list &&
    (this.state.selectedNodeIndex < this.props.data.list.length - 1 ||
      this.state.page + 1 < this.state.pages);

  addAction = (values) => {
    const { selectedNote, queryParams } = this.state;
    if (selectedNote) {
      return this.props
        .addAction(selectedNote.visitNoteID, values, this.state.queryParams)
        .then(() => {
          if (values.clearMskFlag || values.setMskFlag) {
            this.fetch();
            this.props
              .getNote(selectedNote.visitNoteID, this.state.queryParams)
              .then((response) => {
                const data = _.get(response, 'payload.data', null);
                if (data) {
                  this.setState({ selectedNote: data });
                }
              });
          } else {
            this.props.getActions(selectedNote.visitNoteID, queryParams);
          }
          this.setState({
            showNotes: false,
          });
        });
    }
  };

  preFetch = (page, perPage) => {
    return new Promise((resolve) => {
      this.setState(
        {
          page: page !== this.state.page ? page : this.state.page,
          perPage,
        },
        () => resolve(this.fetch(page, perPage)),
      );
    });
  };

  fetch = (page = this.state.page, perPage = this.state.perPage) => {
    return this.props
      .fetchNotes(
        this.state.page,
        this.state.perPage,
        this.state.sort,
        this.state.search,
        this.state.filter,
        this.state.filters,
      )
      .then((response) => {
        if (response) {
          this.setState({
            pages:
              response.payload.data && response.payload.data.total
                ? Math.ceil(response.payload.data.total / this.state.perPage)
                : '0',
          });
        }
        return response;
      });
  };

  setSort = (sort) => {
    if (this.state.sort.indexOf(sort) > -1) {
      if (this.state.sort.indexOf('desc ') === 0) {
        sort = `asc ${sort}`;
      } else {
        sort = `desc ${sort}`;
      }
    } else {
      sort = `desc ${sort}`;
    }
    return this.setState(
      {
        sort: sort,
      },
      () => this.fetch(),
    );
  };

  setFilter = (filter) => {
    return this.setState(
      {
        filter,
      },
      () => {
        const query = this.props.location.query;
        if (filter) {
          query.filter = filter;
        } else {
          delete query.filter;
        }
        hashHistory.push({
          pathname: this.props.location.pathname,
          query: query,
        });
        this.fetch();
      },
    );
  };

  setSearch = (search) => {
    return this.setState(
      {
        search,
      },
      () => this.fetch(),
    );
  };

  getActions = () => {
    if (this.state.selectedNote) {
      if (this.props.actions[this.state.selectedNote.visitNoteID]) {
        return this.props.actions[this.state.selectedNote.visitNoteID];
      }
    }
    return {};
  };

  getEncounters = () => {
    if (this.state.selectedNote) {
      if (this.props.encounters[this.state.selectedNote.visitNoteID]) {
        return this.props.encounters[this.state.selectedNote.visitNoteID];
      }
    }
    return {};
  };

  getBullets = () => {
    if (this.state.selectedNote) {
      if (this.props.bullets[this.state.selectedNote.visitNoteID]) {
        return this.props.bullets[this.state.selectedNote.visitNoteID];
      }
    }
    return {};
  };

  getMedications = () => {
    if (this.state.selectedNote) {
      if (this.props.medications[this.state.selectedNote.visitNoteID]) {
        return this.props.medications[this.state.selectedNote.visitNoteID];
      }
    }
    return {};
  };

  getHistory = () => {
    if (this.state.selectedNote) {
      if (this.props.history[this.state.selectedNote.patientID]) {
        return this.props.history[this.state.selectedNote.patientID];
      }
    }
    return {};
  };

  getNoteLink = (id) =>
    `${window.location.protocol}//${window.location.host}/#/visit-note/${id}`;

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters: null,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            if (item.masterId) {
              options.push({
                id: item.id,
                masterId: item.masterId,
                lastName: item.lastName,
                firstName: item.firstName,
              });
            }
          });
        }
        return options;
      });
  };

  changeFilters(params) {
    this.setState({ filters: { ...this.filters, ...params } }, () =>
      this.fetch(),
    );
  }

  render() {
    const {
      data,
      isLoading,
      limits,
      lookups,
      view,
      title,
      isActionsLoading,
      isEncountersLoading,
      isBulletsLoading,
      isActionSubmitting,
      isMedicationsLoading,
      isHistoryLoading,
      isExecutive
    } = this.props;
    const { sort, filter, viewLayout } = this.state;
    const isChartReview = view === 'CHART_REVIEW';
    const isCptReview = view === 'CPT_REVIEW';
    const isFollowUp = view === 'FOLLOW_UP';
    const isAll = view === 'ALL';
    const isAlerts = view === 'ALERTS';
    const isProtocolFlags = view === 'PROTOCOL_FLAGS';

    let auditLogData = [];
    if (this.props.audit) {
      auditLogData = Object.keys(this.props.audit).map((el) => ({
        title: el,
        value: this.props.audit[el].toLocaleString(),
      }));
    }

    return (
      <div id="content" className="clinic-activity">
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={[
                'Practice Management',
                [
                  {
                    title: 'Clinic Activity',
                    route: '/clinic-activity/all',
                    active: isAll,
                  },
                  {
                    title: 'Chart Review',
                    route: '/clinic-activity/chart-review',
                    active: isChartReview,
                  },
                  {
                    title: 'Review Req',
                    route: '/clinic-activity/cpt-review-req',
                    active: isCptReview,
                  },
                  {
                    title: 'Follow Up',
                    route: '/clinic-activity/follow-up',
                    active: isFollowUp,
                  },
                  {
                    title: 'Protocol Flags',
                    route: '/clinic-activity/protocol-flags',
                    active: isProtocolFlags,
                  },
                  {
                    title: 'Alerts',
                    route: '/clinic-activity/alerts',
                    active: isAlerts,
                  },
                ],
              ]}
              icon="fa fa-fw fa-hospital-o"
              className=""
            />
          </div>
          <div className="table-cell">
            {isChartReview && <InfoBarBase data={auditLogData} />}
            {!isChartReview && (
              <InfoBar
                className=""
                total={data.total}
                pages={this.state.pages}
                page={this.state.page + 1}
              />
            )}
          </div>
        </div>
        <WidgetGrid>
          <div className="tablet-list-navigation">
            <div className="tablet-nav-list">
              <VisitNotesListMobile
                data={data}
                limits={limits}
                title={title}
                isLoading={isLoading}
                selected={this.state.selectedNote}
                fetchData={this.preFetch}
                selectNote={this.selectNote}
                onNextPage={this.nextPage}
                onPrevPage={this.prevPage}
              />
            </div>
            <div className="tablet-nav-sort">
              <Dropdown className="btn-group" id="table-nav-sort">
                <Dropdown.Toggle className="btn dropdown-toggle">
                  Sort{' '}
                  {sort.indexOf('dateOfService') > -1 && (
                    <strong>Date Of Service</strong>
                  )}
                  {sort.indexOf('visitNoteID') > -1 && (
                    <strong>Visit Note ID</strong>
                  )}
                  {sort.indexOf('patientID') > -1 && (
                    <strong>Patient ID</strong>
                  )}{' '}
                  {sort.indexOf('desc') === 0 && <strong>DESC</strong>}
                  {sort.indexOf('asc') === 0 && <strong>ASC</strong>}
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu pull-right">
                  <MenuItem
                    className={
                      sort.indexOf('dateOfService') > -1 ? 'active' : ''
                    }
                    onClick={() => this.setSort('dateOfService')}
                  >
                    Date Of Service
                    {sort.indexOf('dateOfService') > -1 &&
                      sort.indexOf('desc') === 0 && (
                        <i className="fa fa-sort-numeric-desc pull-right" />
                      )}
                    {sort.indexOf('dateOfService') > -1 &&
                      sort.indexOf('asc') === 0 && (
                        <i className="fa fa-sort-numeric-asc pull-right" />
                      )}
                  </MenuItem>
                  <MenuItem
                    className={sort.indexOf('visitNoteID') > -1 ? 'active' : ''}
                    onClick={() => this.setSort('visitNoteID')}
                  >
                    Visit Note ID
                    {sort.indexOf('visitNoteID') > -1 &&
                      sort.indexOf('desc') === 0 && (
                        <i className="fa fa-sort-numeric-desc pull-right" />
                      )}
                    {sort.indexOf('visitNoteID') > -1 &&
                      sort.indexOf('asc') === 0 && (
                        <i className="fa fa-sort-numeric-asc pull-right" />
                      )}
                  </MenuItem>
                  <MenuItem
                    className={sort.indexOf('patientID') > -1 ? 'active' : ''}
                    onClick={() => this.setSort('patientID')}
                  >
                    Patient ID
                    {sort.indexOf('patientID') > -1 &&
                      sort.indexOf('desc') === 0 && (
                        <i className="fa fa-sort-numeric-desc pull-right" />
                      )}
                    {sort.indexOf('patientID') > -1 &&
                      sort.indexOf('asc') === 0 && (
                        <i className="fa fa-sort-numeric-asc pull-right" />
                      )}
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="tablet-nav-filter">
              <Dropdown className="btn-group" id="tablet-nav-filter">
                <Dropdown.Toggle className="btn dropdown-toggle">
                  Filter{' '}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem
                    className={filter.indexOf('locked') === 0 ? 'active' : ''}
                    onClick={() => this.setFilter('locked')}
                  >
                    Locked
                  </MenuItem>
                  <MenuItem
                    className={filter.indexOf('unlocked') === 0 ? 'active' : ''}
                    onClick={() => this.setFilter('unlocked')}
                  >
                    Unlocked
                  </MenuItem>
                  {isProtocolFlags && (
                    <MenuItem
                      className={filter.indexOf('msk') === 0 ? 'active' : ''}
                      onClick={() => this.setFilter('msk')}
                    >
                      MSK
                    </MenuItem>
                  )}
                  {isProtocolFlags && (
                    <MenuItem
                      className={
                        filter.indexOf('diabetes') === 0 ? 'active' : ''
                      }
                      onClick={() => this.setFilter('diabetes')}
                    >
                      Diabetes
                    </MenuItem>
                  )}
                  {/* {isProtocolFlags && (
                    <MenuItem
                      className={
                        filter.indexOf('reviewed') === 0 ? 'active' : ''
                      }
                      onClick={() => this.setFilter('reviewed')}
                    >
                      Reviewed
                    </MenuItem>
                  )} */}
                  {isProtocolFlags && (
                    <MenuItem
                      className={filter.indexOf('bmi') === 0 ? 'active' : ''}
                      onClick={() => this.setFilter('bmi')}
                    >
                      BMI
                    </MenuItem>
                  )}
                  {isAlerts && (
                    <MenuItem
                      className={filter.indexOf('bmi') === 0 ? 'active' : ''}
                      onClick={() => this.setFilter('bmi')}
                    >
                      BMI
                    </MenuItem>
                  )}
                  <MenuItem divider />
                  <MenuItem onClick={() => this.setFilter('')}>
                    <i className="fa fa-power-off" /> Clear
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="tablet-nav-search">
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search..."
                />
                <div className="input-group-btn">
                  <button className="btn btn-default" type="button">
                    <i className="fa fa-search" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="telemetry-filters">
            <FiltersForm
              searchUsers={this.searchUsers}
              onSubmit={this.changeFilters}
            />
            <div className="view-switch hidden-xs">
              <div className="btn-group">
                <button
                  type="button"
                  onClick={() => this.changeView('list')}
                  className={`btn btn-default ${
                    viewLayout === 'list' ? 'active' : ''
                  }`}
                >
                  <i className="fa fa-list"></i>{' '}
                </button>
                <button
                  type="button"
                  onClick={() => this.changeView('detail')}
                  className={`btn btn-default ${
                    viewLayout === 'detail' ? 'active' : ''
                  }`}
                >
                  <i className="fa fa-file-text-o"></i>
                </button>
              </div>
            </div>
          </div>
          {viewLayout === 'detail' && (
            <div className="table-layout detail">
              <div className="table-cell notes-list">
                {/* widget */}
                <JarvisWidget
                  colorbutton={false}
                  editbutton={false}
                  togglebutton={false}
                  deletebutton={false}
                  color="white"
                  fullscreenbutton={true}
                >
                  <header>
                    <h2>
                      <strong>Visit</strong> <i>Notes</i>
                    </h2>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Sort{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              sort.indexOf('dateOfService') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('dateOfService')}
                          >
                            Date Of Service
                            {sort.indexOf('dateOfService') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('dateOfService') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('visitNoteID') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('visitNoteID')}
                          >
                            Visit Note ID
                            {sort.indexOf('visitNoteID') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('visitNoteID') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('patientID') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('patientID')}
                          >
                            Patient ID
                            {sort.indexOf('patientID') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('patientID') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Filter{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              filter.indexOf('locked') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('locked')}
                          >
                            Locked
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('unlocked') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('unlocked')}
                          >
                            Unlocked
                          </MenuItem>
                          {isProtocolFlags && (
                            <MenuItem
                              className={
                                filter.indexOf('msk') === 0 ? 'active' : ''
                              }
                              onClick={() => this.setFilter('msk')}
                            >
                              MSK
                            </MenuItem>
                          )}
                          {isProtocolFlags && (
                            <MenuItem
                              className={
                                filter.indexOf('diabetes') === 0 ? 'active' : ''
                              }
                              onClick={() => this.setFilter('diabetes')}
                            >
                              Diabetes
                            </MenuItem>
                          )}
                          <MenuItem
                            className={
                              filter.indexOf('reviewed') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('reviewed')}
                          >
                            Reviewed
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('not reviewed') === 0
                                ? 'active'
                                : ''
                            }
                            onClick={() => this.setFilter('not reviewed')}
                          >
                            Not Reviewed
                          </MenuItem>
                          <MenuItem divider />
                          <MenuItem onClick={() => this.setFilter('')}>
                            <i className="fa fa-power-off" /> Clear
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </header>
                  <div className="clinic-activity-widget-wrapper">
                    <div className="widget-body clinic-activity-widget-body">
                      <VisitNotesList
                        simpleView={isChartReview || isFollowUp}
                        data={data}
                        limits={limits}
                        isLoading={isLoading}
                        selected={this.state.selectedNote}
                        fetchData={this.preFetch}
                        selectNote={this.selectNote}
                        onSearchChange={this.setSearch}
                        ref="VisitNotesList"
                        page={this.state.page}
                        perPage={this.state.perPage}
                        search={this.state.search}
                      />
                    </div>
                    {/* end widget content */}
                  </div>
                  {/* end widget div */}
                </JarvisWidget>
                {/* end widget */}
              </div>
              <div className="table-cell chart-review">
                <JarvisWidget
                  colorbutton={false}
                  editbutton={false}
                  togglebutton={false}
                  deletebutton={false}
                  color="white"
                  fullscreenbutton={true}
                >
                  <header>
                    {this.state.selectedNote && (
                      <h2>
                        <strong>{this.state.selectedNote.visitNoteID}</strong>{' '}
                        <i>Visit Note ID</i>
                      </h2>
                    )}
                    {this.state.selectedNote && (
                      <div className="widget-toolbar">
                        <a disabled={isExecutive}
                          className="btn btn-primary"
                          onClick={() => this.toggleNotes(false, true)}
                        >
                          <i className="fa fa-pencil" />
                          <span className="hidden-xs">
                            &nbsp;Add Review Notes
                          </span>
                        </a>
                      </div>
                    )}
                    {this.state.selectedNote && (
                      <div className="widget-toolbar">
                        <a
                          className={`btn btn-default ${
                            this.canPrevNote() && !isLoading ? '' : 'disabled'
                          }`}
                          onClick={this.prevNote}
                        >
                          <i className="glyphicon glyphicon-chevron-left" />
                        </a>
                        <a
                          className={`btn btn-default ${
                            this.canNextNote() && !isLoading ? '' : 'disabled'
                          }`}
                          onClick={this.nextNote}
                        >
                          <i className="glyphicon glyphicon-chevron-right" />
                        </a>
                      </div>
                    )}
                    {this.state.selectedNote && (
                      <div className="widget-toolbar">
                        <CopyToClipboard
                          text={this.getNoteLink(
                            this.state.selectedNote.visitNoteID,
                          )}
                        >
                          <a
                            className="btn btn-default"
                            title="Copy Visit Note's Link"
                          >
                            <i className="glyphicon glyphicon-link" />
                          </a>
                        </CopyToClipboard>
                      </div>
                    )}
                  </header>
                  <div className="clinic-activity-widget-wrapper">
                    <VisitView
                      ref="VisitViewWrapper"
                      data={this.state.selectedNote}
                      actions={this.getActions()}
                      encounters={this.getEncounters()}
                      bullets={this.getBullets()}
                      limits={limits}
                      showNotes={this.state.showNotes}
                      editFlagsMode={this.state.editFlagsMode}
                      toggleNotes={this.toggleNotes}
                      addAction={this.addAction}
                      isEncountersLoading={isEncountersLoading}
                      isActionsLoading={isActionsLoading}
                      isBulletsLoading={isBulletsLoading}
                      isActionSubmitting={isActionSubmitting}
                      lookups={lookups}
                      medications={this.getMedications()}
                      isMedicationsLoading={isMedicationsLoading}
                      view={view}
                      history={this.getHistory()}
                      isHistoryLoading={isHistoryLoading}
                    />
                  </div>
                </JarvisWidget>
              </div>
            </div>
          )}
          {viewLayout === 'list' && (
            <div className="table-layout list">
              <div className="table-cell notes-list">
                {/* widget */}
                <JarvisWidget
                  colorbutton={false}
                  editbutton={false}
                  togglebutton={false}
                  deletebutton={false}
                  color="white"
                  fullscreenbutton={true}
                >
                  <header>
                    <h2>
                      <strong>Visit</strong> <i>Notes</i>
                    </h2>
                    <div className="widget-toolbar">
                      <a disabled={isExecutive}
                        className="btn btn-primary"
                        onClick={() => this.toggleNotes(false, true)}
                      >
                        <i className="fa fa-pencil" />
                        <span className="hidden-xs">
                          &nbsp;Add Review Notes
                        </span>
                      </a>
                    </div>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Sort{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              sort.indexOf('dateOfService') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('dateOfService')}
                          >
                            Date Of Service
                            {sort.indexOf('dateOfService') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('dateOfService') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('visitNoteID') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('visitNoteID')}
                          >
                            Visit Note ID
                            {sort.indexOf('visitNoteID') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('visitNoteID') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                          <MenuItem
                            className={
                              sort.indexOf('patientID') > -1 ? 'active' : ''
                            }
                            onClick={() => this.setSort('patientID')}
                          >
                            Patient ID
                            {sort.indexOf('patientID') > -1 &&
                              sort.indexOf('desc') === 0 && (
                                <i className="fa fa-sort-numeric-desc pull-right" />
                              )}
                            {sort.indexOf('patientID') > -1 &&
                              sort.indexOf('asc') === 0 && (
                                <i className="fa fa-sort-numeric-asc pull-right" />
                              )}
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="widget-toolbar">
                      <Dropdown className="btn-group" id="widget-demo-dropdown">
                        <Dropdown.Toggle className="btn btn-xs dropdown-toggle">
                          Filter{' '}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu pull-right">
                          <MenuItem
                            className={
                              filter.indexOf('locked') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('locked')}
                          >
                            Locked
                          </MenuItem>
                          <MenuItem
                            className={
                              filter.indexOf('unlocked') === 0 ? 'active' : ''
                            }
                            onClick={() => this.setFilter('unlocked')}
                          >
                            Unlocked
                          </MenuItem>
                          {isProtocolFlags && (
                            <MenuItem
                              className={
                                filter.indexOf('msk') === 0 ? 'active' : ''
                              }
                              onClick={() => this.setFilter('msk')}
                            >
                              MSK
                            </MenuItem>
                          )}
                          {isProtocolFlags && (
                            <MenuItem
                              className={
                                filter.indexOf('diabetes') === 0 ? 'active' : ''
                              }
                              onClick={() => this.setFilter('diabetes')}
                            >
                              Diabetes
                            </MenuItem>
                          )}
                          <MenuItem divider />
                          <MenuItem onClick={() => this.setFilter('')}>
                            <i className="fa fa-power-off" /> Clear
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </header>
                  <div className="clinic-activity-widget-wrapper">
                    <div className="widget-body clinic-activity-widget-body">
                      <VisitNotesTable
                        ref="VisitNotesTable"
                        simpleView={false}
                        data={data}
                        limits={limits}
                        isLoading={isLoading}
                        selected={this.state.selectedNote}
                        fetchData={this.preFetch}
                        selectNote={this.selectNote}
                        onSearchChange={this.setSearch}
                        actions={this.getActions()}
                        encounters={this.getEncounters()}
                        bullets={this.getBullets()}
                        lookups={lookups}
                        isEncountersLoading={isEncountersLoading}
                        isActionsLoading={isActionsLoading}
                        isBulletsLoading={isBulletsLoading}
                        isActionSubmitting={isActionSubmitting}
                        medications={this.getMedications()}
                        isMedicationsLoading={isMedicationsLoading}
                        view={view}
                        history={this.getHistory()}
                        isHistoryLoading={isHistoryLoading}
                        page={this.state.page}
                        perPage={this.state.perPage}
                        search={this.state.search}
                        showNotes={this.state.showNotes}
                        toggleNotes={this.toggleNotes}
                        addAction={this.addAction}
                      />
                    </div>
                    {/* end widget content */}
                  </div>
                  {/* end widget div */}
                </JarvisWidget>
                {/* end widget */}
              </div>
            </div>
          )}
        </WidgetGrid>
      </div>
    );
  }
}

const selectLocation = (state) => {
  if (state.currentUser.queryParams.practiceId && state.locations.list) {
    return state.locations.list.find(
      (el) => el.id === state.currentUser.queryParams.practiceId,
    );
  }
  return null;
};
export default connect(
  (state) => ({
    isEncountersLoading: state.visitNotes.isEncountersLoading,
    isActionsLoading: state.visitNotes.isActionsLoading,
    isBulletsLoading: state.visitNotes.isBulletsLoading,
    isActionSubmitting: state.visitNotes.isActionSubmitting,
    isMedicationsLoading: state.visitNotes.isMedicationsLoading,
    actions: selectActions(state),
    encounters: selectEncounters(state),
    bullets: selectBullets(state),
    medications: selectMedications(state),
    currentUser: state.currentUser,
    history: state.patients.history,
    isHistoryLoading: state.patients.isHistoryLoading,
    currentLocation: selectLocation(state),
    audit: state.visitNotes.audit,
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getActions: (visitNoteID, params) =>
      dispatch(requestActions(visitNoteID, params)),
    addAction: (visitNoteID, data, params) =>
      dispatch(addAction(visitNoteID, data, params)),
    getEncounters: (patientID, visitNoteID, params) =>
      dispatch(requestEncounters(patientID, visitNoteID, params)),
    getBullets: (visitNoteID, params) =>
      dispatch(requestBullets(visitNoteID, params)),
    getNote: (visitNoteID, params) =>
      dispatch(requestVisitNote(visitNoteID, params)),
    getMedications: (visitNoteID, patientID, serviceDate, tenantId) =>
      dispatch(
        requestMedications(visitNoteID, patientID, serviceDate, tenantId),
      ),
    getHistory: (patientID, params) =>
      dispatch(requestClaimsHistory(patientID, params)),
    getAuditLog: (params) => dispatch(requestAuditLog(params)),
  }),
)(ClinicActivityLayout);



// WEBPACK FOOTER //
// ./src/routes/management/components/ClinicActivityLayout.js